/* @flow */
// typecheck: ignore file
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import React from 'react';
import cx from 'classnames';
import focusNode from 'utils/focusNode';
import pickInputElementProps from 'utils/pickInputElementProps';
import Glyph from 'components/Glyph.jsx';
import type { GlyphName } from '@remind/r101-glyphs';

import './styles/Input.scss';

type Props = {
  size?: 'large' | 'medium',
  width?: 'full' | 'auto',
  autofocus?: boolean,
  append?: any,
  glyph?: GlyphName,
  className?: string,
};

class Input extends React.Component {
  props: Props;

  static propClasses = {
    size: {
      large: 'Input--large',
      xlarge: 'Input-xlarge',
    },
    width: {
      auto: 'Input--auto',
      full: 'Input--full',
    },
  };

  static defaultProps = {
    size: 'medium',
    autofocus: false,
    width: 'full',
  };

  componentDidMount() {
    if (this.props.autofocus) {
      // Prevents the cursor from being placed at the start of the text
      const value = this.getInputNode().value;
      this.getInputNode().value = '';
      focusNode(this.getInputNode());
      this.getInputNode().value = value;
    }
  }

  getInputNode = () => {
    return this.refs.input;
  };

  focus = () => {
    this.getInputNode().focus();
  };

  renderPendedInput(inputProps: ?Object) {
    const { append, glyph } = this.props;

    return (
      <div
        // $FlowIssue
        className={cx('Input--hasPend', {
          'Input--hasGlyph': glyph,
          'Input--hasAppend': append,
        })}>
        {glyph &&
          <div className="Input-pend Input-glyph">
            <Glyph name={glyph} color="eclipse" size="large" />
          </div>
        }
        <input
          {...inputProps}
          ref="input"
          // $FlowIssue
          className={cx('Input', {
            'Input--hasGlyph-input': glyph,
            'Input--hasAppend-input': append,
          }, getPropClassesFromInstance(this), this.props.className)}
        />
        {append &&
          <div className="Input-pend Input-append">
            {append}
          </div>
        }
      </div>
    );
  }

  render() {
    const { append, glyph, className } = this.props;
    const inputProps = pickInputElementProps(this.props);

    if (append || glyph) {
      return this.renderPendedInput(inputProps);
    }

    return (
      <input
        {...inputProps}
        ref="input"
        className={cx('Input', getPropClassesFromInstance(this), className)}
      />
    );
  }
}

export default Input;



// WEBPACK FOOTER //
// ./src/components/Input.jsx